<ng-template #panel>
  <cmp-dialog-surface
    [variant]="variant()"
    [width]="width()"
    [title]="title()"
    [description]="description()"
    [icon]="icon()"
    [dismissible]="dismissible()"
    [closeLabel]="closeLabel()"
    [showActions]="showActions()"
    [titleId]="titleId"
    [descId]="descId"
    (closeClick)="requestClose()"
  >
    <ng-content />
    <ng-content select="[cmpDialogActions]" ngProjectAs="[cmpDialogActions]" />
  </cmp-dialog-surface>
</ng-template>
